import { Role } from "../model/token-model/role.model";
import Task from "../pages/admin/task/task";
import TaskCalender from "../pages/user/task/taskCalender/taskCalender";
import { TokenService } from "../services/token.service";

export const TaskWrapper = () => {
    const role = TokenService.getRole();
    return role === Role.COREMEMBERS ? <Task /> : <TaskCalender />;
}